// extracted by mini-css-extract-plugin
export default {"btn":"Back2NewsButton_btn__Pldle","icon":"Back2NewsButton_icon__2QgHp"};